/* import __COLOCATED_TEMPLATE__ from './list.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { DEFAULT_ACTION_COLUMNS } from 'embercom/models/workflow-connector/constants/available-action-columns';

interface Signature {
  Args: Args;
}

interface Args {
  workflowActions: Array<any>;
  selectedColumns?: Array<any>;
}

export default class List extends Component<Signature> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get selectedColumns() {
    let selectedColumns;

    if (this.args.selectedColumns) {
      selectedColumns = this.args.selectedColumns;
    } else {
      selectedColumns = DEFAULT_ACTION_COLUMNS;
    }

    return selectedColumns?.map((column: any) => {
      if (column.valuePath === 'name') {
        column.label = this.intl.t('workflow-connector.list.columns.name');
      } else {
        column.label = this.intl.t(`workflow-connector.list.columns.${column.valuePath}`);
      }

      if (column.hasTooltip) {
        if (column.valuePath === 'customerVerification') {
          column.tooltip = this.intl.t(
            `workflow-connector.list.columns.${column.valuePath}-tooltip`,
          );
        } else {
          column.tooltip = this.intl.t(
            `workflow-connector.list.columns.${column.valuePath}-tooltip`,
          );
        }
      }

      if (column.valuePath === 'successRate') {
        column.isSortable = this.healthMetricsEnabled;
      }

      return column;
    });
  }

  get healthMetricsEnabled() {
    return this.appService.app.canUseFeature('data-connectors-health-metrics-enhancements');
  }

  get customActionsRoute() {
    return 'apps.app.settings.app-settings.custom-actions.custom-action-health';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::List': typeof List;
    'workflow-connector/list': typeof List;
  }
}
